import { styled } from "styled-components";
import { motion } from "framer-motion";

export const StyledSection = styled.section`
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const HeadingContainer = styled.div`
  padding: 100px 0 70px; /* Increased padding from 80px 0 60px to 100px 0 70px for more space */
  width: 100%;
  display: flex;
  justify-content: center;
  transform-origin: center top;
  transition: transform 0.2s ease-out;

  /*
   * Adaptive scaling for small height screens
   * 
   * PROBLEM:
   * - Heading has fixed size and overlaps with cards on small screens
   * - Users cannot see full content properly on low height monitors
   * 
   * SOLUTION:
   * - Proportional heading scaling using transform: scale()
   * - Same scaling points as SolutionCard for consistency
   * - Scale ranges from 99% (1000px) to 25% (260px)
   * 
   * RESULT:
   * - Heading scales proportionally with cards
   * - No overlap between heading and cards
   * - Consistent visual balance at all screen heights
   */

  @media (max-height: 1000px) {
    transform: scale(0.99);
  }

  @media (max-height: 990px) {
    transform: scale(0.98);
  }

  @media (max-height: 980px) {
    transform: scale(0.97);
  }

  @media (max-height: 970px) {
    transform: scale(0.96);
  }

  @media (max-height: 960px) {
    transform: scale(0.95);
  }

  @media (max-height: 950px) {
    transform: scale(0.94);
  }

  @media (max-height: 940px) {
    transform: scale(0.93);
  }

  @media (max-height: 930px) {
    transform: scale(0.92);
  }

  @media (max-height: 920px) {
    transform: scale(0.91);
  }

  @media (max-height: 910px) {
    transform: scale(0.9);
  }

  @media (max-height: 900px) {
    transform: scale(0.89);
  }

  @media (max-height: 890px) {
    transform: scale(0.88);
  }

  @media (max-height: 880px) {
    transform: scale(0.87);
  }

  @media (max-height: 870px) {
    transform: scale(0.86);
  }

  @media (max-height: 860px) {
    transform: scale(0.85);
  }

  @media (max-height: 850px) {
    transform: scale(0.84);
  }

  @media (max-height: 840px) {
    transform: scale(0.83);
  }

  @media (max-height: 830px) {
    transform: scale(0.82);
  }

  @media (max-height: 820px) {
    transform: scale(0.81);
  }

  @media (max-height: 810px) {
    transform: scale(0.8);
  }

  @media (max-height: 800px) {
    transform: scale(0.79);
  }

  @media (max-height: 790px) {
    transform: scale(0.78);
  }

  @media (max-height: 780px) {
    transform: scale(0.77);
  }

  @media (max-height: 770px) {
    transform: scale(0.76);
  }
`;

export const Heading = styled.h2`
  color: #1d1d1d;
  opacity: 0.85;
  text-align: center;
  font-size: 44px;
  font-weight: 500;
  line-height: 130%;
  letter-spacing: -0.02em;
  width: 778px;
  max-width: 100%;
  margin: 0;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    margin-bottom: 40px;
    font-size: 28px;
    letter-spacing: unset;
  }
`;

export const HeadingHighlight = styled.span`
  color: rgba(29, 29, 29, 0.5);
`;

export const HeadingHighlightDot = styled.img`
  margin-bottom: -1px;
  position: relative;
`;

export const CardsContainer = styled(motion.div)`
  display: flex;
  width: max-content;
  height: calc(
    95vh - 240px
  ); /* Adjusted from 210px to 240px to account for increased heading space */
  align-items: center;
  margin-top: 30px; /* Increased margin-top from 20px to 30px for more space between heading and cards */
`;
